import React, { useState, useEffect } from "react";
import { HTTP } from "../../api/http-common";
import CouponCard from "./../../component/CouponCard"
import Pagination from '../../component/pagination';
import { useParams } from "react-router-dom";

function VendorProfileCoupon({ backgroundColor = true }) {
  const { id } = useParams();
  const access_token = (localStorage.getItem('access_token'));
  // const [categoriesList, setCategoriesList] = useState([]);
  // const [activeCategory, setActiveCategory] = useState(1);
  const [filteredCoupons, setFilteredCoupons] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagination, setPagination] = useState({ page: '1', limit: '10' });
  const [filterType, setFilterType] = useState("all");
  // const [search, setSearch] = useState({ category_id: '' });
  const [currentPage, setCurrentPage] = useState(1);

  const fetchCoupons = async (couponData) => {
    let config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    }
    let fields = {
      filters: {
        vendor_id: id,
        // coupon_type: filterType
      },
      pagination: pagination,
      sorting: { field: 'id', type: 'desc' },
    };
    HTTP.post('coupon/customer/list', fields, config)
      .then((response) => {
        const data = response.data;
        if (response.status === 200) {
          setFilteredCoupons(data.contents);
          setTotal(data.total_count);
        }
        if (response.status === 204) {
          // setAaMasters([])
        }
      })
      .catch((error) => {
        // setError(error)
        // setRerenderFlag(true);
      })
      .finally(() => {
        // setIsLoading(false);
      });
  };
  const onPaginationChange = (page) => {
    setPagination({ ...pagination, page });
  };
  const onLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setPagination({ ...pagination, limit: newLimit, page: 1 });
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    fetchCoupons();
  }, [filterType, currentPage, pagination]);

  return (
    <>
      <div className=''>
        <div className={`container mx-auto rounded-xl pb-4 relative ${backgroundColor == true ? " bg-[#fefefe]" : ''}`}>

          {Array.isArray(filteredCoupons) && filteredCoupons.length > 0 ? (
            <>
            {/* <div className="max-h-[calc(100vh-142px)]"> */}
              {/* <div className=" py-6 pt-8 grid grid-cols-1 xl:grid-cols-2 place-items-center gap-y-10 gap-x-0  max-h-[696px] overflow-y-auto scrollbar-hide custom-theme-scroll border  rounded-[5px] mb-5 bg-[#fefefe] custom-lightest-border vendor-sub-section-structure"> */}
              <div className=" py-6 pt-8 grid grid-cols-1 xl:grid-cols-2 place-items-center gap-y-10 gap-x-0  max-h-[696px] overflow-y-auto scrollbar-hide custom-theme-scroll   rounded-[5px] mb-5  custom-lightest-border vendor-sub-section-structure">
                {filteredCoupons.map((coupon, index) => (
                  <CouponCard key={coupon.id} coupon={coupon} />
                ))}
              </div>
              {/* <div className="custom-container"> */}

              <Pagination total={total} pagination={pagination} handlePageChange={onPaginationChange} handleLimitChange={onLimitChange} />
              {/* </div> */}
            {/* </div> */}
            </>
          ) : (
            <div className="   py-6">
              <p className="text-center font-semibold text-xl text-[#6c1cff]">Deals not found</p>
            </div>
          )}

        </div>
      </div>

    </>
  )
}

export default VendorProfileCoupon